import type { InvocationShapeInfo } from '../../../types/backend';

/** The server's warning per offered tool; a tool with none is left out. */
export const toolWarningsOf = (shape: InvocationShapeInfo | null): Record<string, string> => Object.fromEntries(
  (shape?.tools ?? []).filter((t) => t.warning).map((t) => [t.action_id, t.warning as string]),
);
